'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    theme = Object.assign({}, baseTheme(theme), theme);

    insertKeyFrames.call(this);

    var navigationImg = {
        width: theme.gutter + 'px',
        height: theme.gutter + 6 + 'px',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: 'cover'
    };

    var styleList = _aphroditeJss.StyleSheet.create({
        root: {
            width: '100%',
            height: '100%',
            backgroundColor: theme.background,
            padding: theme.padding,
            display: 'flex',
            flexDirection: 'column',
            position: 'relative'
        },
        contentWrapper: {
            display: 'flex',
            flexDirection: 'row',
            flex: 1,
            position: 'relative'
        },
        navigationRight: {
            right: theme.navigationNextRightPosition
        },
        navigationLeft: {
            marginRight: theme.gutter * 2 + 'px',
            left: theme.navigationBackLeftPosition
        },
        navigationImgLeft: Object.assign({}, navigationImg, {
            left: 0,
            backgroundImage: 'url("' + theme.leftNavImg + '")'
        }),
        navigationImgRight: Object.assign({}, navigationImg, {
            right: 0,
            backgroundImage: 'url("' + theme.rightNavImg + '")'
        }),
        wrapper: {
            width: '100%',
            height: '100%',
            margin: '0 auto',
            overflow: 'hidden',
            display: 'flex'
        },
        slideWrapper: {
            height: '100%',
            width: '100%',
            minWidth: '100%',
            overflow: 'hidden'
        },
        animatingToRight: {
            transform: 'translateX(0)',
            animation: 'slider-toRight ' + this.props.timeout + 'ms ease'
        },
        animatingToLeft: {
            transform: 'translateX(-100%)',
            animation: 'slider-toLeft ' + this.props.timeout + 'ms ease'
        },
        navigationWrapper: {
            padding: theme.gutter + 'px 0',
            display: 'flex',
            alignItems: 'center'
        },
        bullet: {
            boxSizing: 'content-box',
            borderRadius: '50%',
            backgroundColor: theme.bulletBackground,
            cursor: 'pointer',
            marginRight: theme.gutter * 2 + 'px',
            width: theme.gutter + 'px',
            height: theme.gutter + 'px',
            display: 'inline-block',

            '&.active': {
                cursor: 'default',
                border: '4px solid ' + theme.activeBulletRadius,
                backgroundColor: theme.hoverNavigationBackground
            }
        },
        counter: {
            position: 'absolute',
            bottom: theme.counterBottomPos,
            right: theme.counterRightPos,
            color: theme.tInversion,
            padding: '0 ' + theme.gutter + 'px',
            borderRadius: '11.5px',
            whiteSpace: 'nowrap',
            backgroundColor: theme.elSecondaryLight,
            fontSize: theme.tsNormal,
            lineHeight: theme.tlNormal,
            textShadow: '0 2px 3px rgba(0, 0, 0, 0.08), 0 0 3px rgba(0, 0, 0, 0.04)'
        }
    });

    return {
        root: (0, _aphroditeJss.css)(styleList.root),
        bullet: (0, _aphroditeJss.css)(styleList.bullet),
        wrapper: (0, _aphroditeJss.css)(styleList.wrapper),
        counter: (0, _aphroditeJss.css)(styleList.counter),
        animation: (0, _aphroditeJss.css)(styleList.animation),
        slideWrapper: (0, _aphroditeJss.css)(styleList.slideWrapper),
        navigationWrapper: (0, _aphroditeJss.css)(styleList.navigationWrapper),
        contentWrapper: (0, _aphroditeJss.css)(styleList.contentWrapper),
        navigationLeft: (0, _aphroditeJss.css)(styleList.navigationLeft),
        navigationRight: (0, _aphroditeJss.css)(styleList.navigationRight),
        animatingToLeft: (0, _aphroditeJss.css)(styleList.animatingToLeft),
        animatingToRight: (0, _aphroditeJss.css)(styleList.animatingToRight),
        navigationImgLeft: (0, _aphroditeJss.css)(styleList.navigationImgLeft),
        navigationImgRight: (0, _aphroditeJss.css)(styleList.navigationImgRight)
    };
};

var _aphroditeJss = require('aphrodite-jss');

var _arrow_left = require('../img/arrow_left.svg');

var _arrow_left2 = _interopRequireDefault(_arrow_left);

var _arrow_right = require('../img/arrow_right.svg');

var _arrow_right2 = _interopRequireDefault(_arrow_right);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var insertKeyFrames = function insertKeyFrames() {
    if (!Object.getPrototypeOf(this).__sliderKeyframesSet) {
        var doc = window.document,
            style = doc.createElement('style'),
            sheet = void 0;

        style.setAttribute('data-meta', 'p24c-slider-jss');

        doc.querySelector('head').insertBefore(style, doc.querySelector('head').firstChild);
        sheet = [].find.call(doc.styleSheets, function (s) {
            return s.ownerNode === style;
        });

        Object.getPrototypeOf(this).__sliderKeyframesSet = true;
        try {
            sheet.insertRule('\n                   @keyframes slider-toLeft {\n                        from {\n                            transform: translateX(0);\n                        }\n    \n                        to {\n                            transform: translateX(-100%);\n                        }\n                   }', sheet.cssRules && sheet.cssRules.length);
            sheet.insertRule('\n                    @-webkit-keyframes slider-toLeft {\n                        from {\n                            transform: translateX(0);\n                        }\n    \n                        to {\n                            transform: translateX(-100%);\n                        }\n                   }', sheet.cssRules && sheet.cssRules.length);

            sheet.insertRule('\n                    @keyframes slider-toRight {\n                        from {\n                            transform: translateX(-100%);\n                        }\n    \n                        to {\n                            transform: translateX(0);\n                        }\n                   }', sheet.cssRules && sheet.cssRules.length);

            sheet.insertRule('\n                    @-webkit-keyframes slider-toRight {\n                        from {\n                            transform: translateX(-100%);\n                        }\n    \n                        to {\n                            transform: translateX(0);\n                        }\n                   }', sheet.cssRules && sheet.cssRules.length);
        } catch (e) {
            window.console && window.console.log(e);
        }
    }
};

var baseTheme = function baseTheme(theme) {
    return {
        padding: 0,
        borderColor: theme.elDivider,
        background: theme.elPrimary,
        bulletBackground: theme.elSecondaryLight,
        activeBulletRadius: theme.elAccent,
        navigationWidth: theme.gutter * 6,
        navigationHeight: theme.gutter * 6,
        navigationBackLeftPosition: 0,
        navigationNextRightPosition: 0,
        navigationBackground: theme.elDivider,
        hoverNavigationBackground: theme.elSecondaryLightActive,
        rightNavImg: _arrow_right2.default,
        leftNavImg: _arrow_left2.default,
        counterBottomPos: theme.gutter * 2,
        counterRightPos: theme.gutter * 3
    };
};